// Generated by npm run icons:generate. Do not edit.
import type { IconName } from './icon-name';
import type { IconData } from './icon-data';

export const ICON_LOADERS = {
  "ack-accept": () => import('./data/ack-accept.icon'),
  "ack-reject": () => import('./data/ack-reject.icon'),
  "active-toggle": () => import('./data/active-toggle.icon'),
  "activity-fill": () => import('./data/activity-fill.icon'),
  "add-communication-img": () => import('./data/add-communication-img.icon'),
  "add-contact-img": () => import('./data/add-contact-img.icon'),
  "add-folder": () => import('./data/add-folder.icon'),
  "add-person": () => import('./data/add-person.icon'),
  "address-marker": () => import('./data/address-marker.icon'),
  "admin-lock": () => import('./data/admin-lock.icon'),
  "ai-agents": () => import('./data/ai-agents.icon'),
  "alerts-and-watchlist": () => import('./data/alerts-and-watchlist.icon'),
  "all-items-filter": () => import('./data/all-items-filter.icon'),
  "all-meetings": () => import('./data/all-meetings.icon'),
  "api": () => import('./data/api.icon'),
  "arrow-left-green": () => import('./data/arrow-left-green.icon'),
  "arrow-left": () => import('./data/arrow-left.icon'),
  "arrow-right": () => import('./data/arrow-right.icon'),
  "arrows-up-down": () => import('./data/arrows-up-down.icon'),
  "attachment": () => import('./data/attachment.icon'),
  "avatar-placeholder": () => import('./data/avatar-placeholder.icon'),
  "bar-chart-stats": () => import('./data/bar-chart-stats.icon'),
  "bar-chart-underlined": () => import('./data/bar-chart-underlined.icon'),
  "bar-chart": () => import('./data/bar-chart.icon'),
  "blankstate": () => import('./data/blankstate.icon'),
  "bloomberg": () => import('./data/bloomberg.icon'),
  "breadcrumbs-chevron": () => import('./data/breadcrumbs-chevron.icon'),
  "building": () => import('./data/building.icon'),
  "calculator": () => import('./data/calculator.icon'),
  "calendar-end": () => import('./data/calendar-end.icon'),
  "calendar-events-and-pinnakl": () => import('./data/calendar-events-and-pinnakl.icon'),
  "calendar-small": () => import('./data/calendar-small.icon'),
  "calendar-start": () => import('./data/calendar-start.icon'),
  "campaign-status": () => import('./data/campaign-status.icon'),
  "center-align": () => import('./data/center-align.icon'),
  "chart-arrow-up-in-circle": () => import('./data/chart-arrow-up-in-circle.icon'),
  "chart-performance-nav-icon": () => import('./data/chart-performance-nav-icon.icon'),
  "chart-performance": () => import('./data/chart-performance.icon'),
  "check-circle": () => import('./data/check-circle.icon'),
  "check-in-circle-fill": () => import('./data/check-in-circle-fill.icon'),
  "check-in-circle": () => import('./data/check-in-circle.icon'),
  "check-in-square": () => import('./data/check-in-square.icon'),
  "check-through-circle": () => import('./data/check-through-circle.icon'),
  "check": () => import('./data/check.icon'),
  "checkbox-empty": () => import('./data/checkbox-empty.icon'),
  "checkbox-type-icon": () => import('./data/checkbox-type-icon.icon'),
  "circle-for-check": () => import('./data/circle-for-check.icon'),
  "circle-sector-incomplete": () => import('./data/circle-sector-incomplete.icon'),
  "clicked": () => import('./data/clicked.icon'),
  "clicks": () => import('./data/clicks.icon'),
  "clip": () => import('./data/clip.icon'),
  "clock": () => import('./data/clock.icon'),
  "close-circle": () => import('./data/close-circle.icon'),
  "close": () => import('./data/close.icon'),
  "cloud-upload": () => import('./data/cloud-upload.icon'),
  "cog": () => import('./data/cog.icon'),
  "coin": () => import('./data/coin.icon'),
  "collapse-panel": () => import('./data/collapse-panel.icon'),
  "columns": () => import('./data/columns.icon'),
  "company": () => import('./data/company.icon'),
  "contacts": () => import('./data/contacts.icon'),
  "copy": () => import('./data/copy.icon'),
  "coupon-icon": () => import('./data/coupon-icon.icon'),
  "credits": () => import('./data/credits.icon'),
  "cross-in-circle": () => import('./data/cross-in-circle.icon'),
  "currency-aed": () => import('./data/currency-aed.icon'),
  "currency-aud": () => import('./data/currency-aud.icon'),
  "currency-brl": () => import('./data/currency-brl.icon'),
  "currency-cad": () => import('./data/currency-cad.icon'),
  "currency-chf": () => import('./data/currency-chf.icon'),
  "currency-clp": () => import('./data/currency-clp.icon'),
  "currency-cny": () => import('./data/currency-cny.icon'),
  "currency-czk": () => import('./data/currency-czk.icon'),
  "currency-dkk": () => import('./data/currency-dkk.icon'),
  "currency-eur": () => import('./data/currency-eur.icon'),
  "currency-gbp": () => import('./data/currency-gbp.icon'),
  "currency-hkd": () => import('./data/currency-hkd.icon'),
  "currency-huf": () => import('./data/currency-huf.icon'),
  "currency-ils": () => import('./data/currency-ils.icon'),
  "currency-inr": () => import('./data/currency-inr.icon'),
  "currency-jpy": () => import('./data/currency-jpy.icon'),
  "currency-krw": () => import('./data/currency-krw.icon'),
  "currency-mxn": () => import('./data/currency-mxn.icon'),
  "currency-nok": () => import('./data/currency-nok.icon'),
  "currency-nzd": () => import('./data/currency-nzd.icon'),
  "currency-pln": () => import('./data/currency-pln.icon'),
  "currency-rub": () => import('./data/currency-rub.icon'),
  "currency-sek": () => import('./data/currency-sek.icon'),
  "currency-sgd": () => import('./data/currency-sgd.icon'),
  "currency-try": () => import('./data/currency-try.icon'),
  "currency-twd": () => import('./data/currency-twd.icon'),
  "currency-uah": () => import('./data/currency-uah.icon'),
  "currency-unknown": () => import('./data/currency-unknown.icon'),
  "currency-usd": () => import('./data/currency-usd.icon'),
  "currency-zar": () => import('./data/currency-zar.icon'),
  "dashboard-preview-campaign-results": () => import('./data/dashboard-preview-campaign-results.icon'),
  "dashboard-preview-deals": () => import('./data/dashboard-preview-deals.icon'),
  "dashboard-preview-most-active-accounts": () => import('./data/dashboard-preview-most-active-accounts.icon'),
  "dashboard-preview-organizations": () => import('./data/dashboard-preview-organizations.icon'),
  "dashboard-preview-recent-contacts": () => import('./data/dashboard-preview-recent-contacts.icon'),
  "dashboard-preview-recent-organizations": () => import('./data/dashboard-preview-recent-organizations.icon'),
  "dashboard-preview-tasks": () => import('./data/dashboard-preview-tasks.icon'),
  "dashboard-preview-top-scorers": () => import('./data/dashboard-preview-top-scorers.icon'),
  "dashboard": () => import('./data/dashboard.icon'),
  "dashed-check-through-circle": () => import('./data/dashed-check-through-circle.icon'),
  "database": () => import('./data/database.icon'),
  "dataset": () => import('./data/dataset.icon'),
  "date-type-icon": () => import('./data/date-type-icon.icon'),
  "deals": () => import('./data/deals.icon'),
  "default-flag": () => import('./data/default-flag.icon'),
  "delete-rounded": () => import('./data/delete-rounded.icon'),
  "delete": () => import('./data/delete.icon'),
  "doc-add": () => import('./data/doc-add.icon'),
  "doc-file": () => import('./data/doc-file.icon'),
  "doc": () => import('./data/doc.icon'),
  "document-no-rounds": () => import('./data/document-no-rounds.icon'),
  "document-with-pencil": () => import('./data/document-with-pencil.icon'),
  "document": () => import('./data/document.icon'),
  "dollar-circle": () => import('./data/dollar-circle.icon'),
  "dollar-in-circle": () => import('./data/dollar-in-circle.icon'),
  "dollar-in-complete-circle": () => import('./data/dollar-in-complete-circle.icon'),
  "dollar-tag": () => import('./data/dollar-tag.icon'),
  "dollar": () => import('./data/dollar.icon'),
  "download-arrow": () => import('./data/download-arrow.icon'),
  "download-tpl": () => import('./data/download-tpl.icon'),
  "download": () => import('./data/download.icon'),
  "dragable-dots": () => import('./data/dragable-dots.icon'),
  "dropdown-arrow-down": () => import('./data/dropdown-arrow-down.icon'),
  "dropdown-triangle": () => import('./data/dropdown-triangle.icon'),
  "due-date-calendar": () => import('./data/due-date-calendar.icon'),
  "e-meeting-fill": () => import('./data/e-meeting-fill.icon'),
  "e-meeting-v2": () => import('./data/e-meeting-v2.icon'),
  "e-meeting": () => import('./data/e-meeting.icon'),
  "ellipsis-h": () => import('./data/ellipsis-h.icon'),
  "email-outline": () => import('./data/email-outline.icon'),
  "emails-and-pinnakl": () => import('./data/emails-and-pinnakl.icon'),
  "ending-cash": () => import('./data/ending-cash.icon'),
  "enter-key": () => import('./data/enter-key.icon'),
  "eraser": () => import('./data/eraser.icon'),
  "excel-big-logo": () => import('./data/excel-big-logo.icon'),
  "exclamation-mark": () => import('./data/exclamation-mark.icon'),
  "expand-item": () => import('./data/expand-item.icon'),
  "export-data": () => import('./data/export-data.icon'),
  "eye-closed": () => import('./data/eye-closed.icon'),
  "eye-open": () => import('./data/eye-open.icon'),
  "file": () => import('./data/file.icon'),
  "filters": () => import('./data/filters.icon'),
  "first-star": () => import('./data/first-star.icon'),
  "fit-screen": () => import('./data/fit-screen.icon'),
  "fit-table": () => import('./data/fit-table.icon'),
  "folder-eye-fill": () => import('./data/folder-eye-fill.icon'),
  "folder-favorite": () => import('./data/folder-favorite.icon'),
  "folder-lock": () => import('./data/folder-lock.icon'),
  "folder-outlined-edged": () => import('./data/folder-outlined-edged.icon'),
  "folder-outlined": () => import('./data/folder-outlined.icon'),
  "folder": () => import('./data/folder.icon'),
  "folders-empty-structure": () => import('./data/folders-empty-structure.icon'),
  "full-arrow-right": () => import('./data/full-arrow-right.icon'),
  "full-screen": () => import('./data/full-screen.icon'),
  "fund-as-sack": () => import('./data/fund-as-sack.icon'),
  "funnel": () => import('./data/funnel.icon'),
  "geo-map": () => import('./data/geo-map.icon'),
  "google-suite-check": () => import('./data/google-suite-check.icon'),
  "google-suite": () => import('./data/google-suite.icon'),
  "government-house": () => import('./data/government-house.icon'),
  "groups": () => import('./data/groups.icon'),
  "horizontal-center": () => import('./data/horizontal-center.icon'),
  "horizontal-left": () => import('./data/horizontal-left.icon'),
  "horizontal-right": () => import('./data/horizontal-right.icon'),
  "horn-fill": () => import('./data/horn-fill.icon'),
  "horn": () => import('./data/horn.icon'),
  "house": () => import('./data/house.icon'),
  "icon-access-control": () => import('./data/icon-access-control.icon'),
  "icon-agg-return": () => import('./data/icon-agg-return.icon'),
  "icon-arrow-up": () => import('./data/icon-arrow-up.icon'),
  "icon-blocked-ip": () => import('./data/icon-blocked-ip.icon'),
  "icon-calendar": () => import('./data/icon-calendar.icon'),
  "icon-collapse": () => import('./data/icon-collapse.icon'),
  "icon-custom-attribute": () => import('./data/icon-custom-attribute.icon'),
  "icon-desktop": () => import('./data/icon-desktop.icon'),
  "icon-down-months": () => import('./data/icon-down-months.icon'),
  "icon-draft": () => import('./data/icon-draft.icon'),
  "icon-enter": () => import('./data/icon-enter.icon'),
  "icon-expand": () => import('./data/icon-expand.icon'),
  "icon-figures": () => import('./data/icon-figures.icon'),
  "icon-folder-settings": () => import('./data/icon-folder-settings.icon'),
  "icon-mobile": () => import('./data/icon-mobile.icon'),
  "icon-month-return": () => import('./data/icon-month-return.icon'),
  "icon-ms-office": () => import('./data/icon-ms-office.icon'),
  "icon-qr-code": () => import('./data/icon-qr-code.icon'),
  "icon-send": () => import('./data/icon-send.icon'),
  "icon-sharpe-ratio": () => import('./data/icon-sharpe-ratio.icon'),
  "icon-star-circle": () => import('./data/icon-star-circle.icon'),
  "icon-std-deviation": () => import('./data/icon-std-deviation.icon'),
  "icon-tablet": () => import('./data/icon-tablet.icon'),
  "icon-time": () => import('./data/icon-time.icon'),
  "icon-total-months": () => import('./data/icon-total-months.icon'),
  "icon-two-factor": () => import('./data/icon-two-factor.icon'),
  "icon-up-months": () => import('./data/icon-up-months.icon'),
  "icon-upload": () => import('./data/icon-upload.icon'),
  "icon-validate": () => import('./data/icon-validate.icon'),
  "icon-warning": () => import('./data/icon-warning.icon'),
  "icon-watermark": () => import('./data/icon-watermark.icon'),
  "import-grid": () => import('./data/import-grid.icon'),
  "in-person-fill": () => import('./data/in-person-fill.icon'),
  "in-person-v2": () => import('./data/in-person-v2.icon'),
  "in-person": () => import('./data/in-person.icon'),
  "inactive-toggle": () => import('./data/inactive-toggle.icon'),
  "investor": () => import('./data/investor.icon'),
  "invoice": () => import('./data/invoice.icon'),
  "kanban-view": () => import('./data/kanban-view.icon'),
  "key-v2": () => import('./data/key-v2.icon'),
  "key": () => import('./data/key.icon'),
  "keyboard-arrow-down": () => import('./data/keyboard-arrow-down.icon'),
  "keyboard-arrow-left": () => import('./data/keyboard-arrow-left.icon'),
  "keyboard-arrow-right": () => import('./data/keyboard-arrow-right.icon'),
  "keyboard-arrow-up": () => import('./data/keyboard-arrow-up.icon'),
  "kinetic-firm-overview": () => import('./data/kinetic-firm-overview.icon'),
  "kinetic-investor-communications": () => import('./data/kinetic-investor-communications.icon'),
  "layout": () => import('./data/layout.icon'),
  "left-align": () => import('./data/left-align.icon'),
  "lightning": () => import('./data/lightning.icon'),
  "link-arrow": () => import('./data/link-arrow.icon'),
  "link-organization": () => import('./data/link-organization.icon'),
  "link": () => import('./data/link.icon'),
  "linked-orgs": () => import('./data/linked-orgs.icon'),
  "linkedin-icon": () => import('./data/linkedin-icon.icon'),
  "linkedin-social": () => import('./data/linkedin-social.icon'),
  "list-add": () => import('./data/list-add.icon'),
  "list-added": () => import('./data/list-added.icon'),
  "list-items-v2": () => import('./data/list-items-v2.icon'),
  "list-items": () => import('./data/list-items.icon'),
  "list-remove": () => import('./data/list-remove.icon'),
  "list-type-icon": () => import('./data/list-type-icon.icon'),
  "login": () => import('./data/login.icon'),
  "long-text": () => import('./data/long-text.icon'),
  "loss-circle": () => import('./data/loss-circle.icon'),
  "loss-graph": () => import('./data/loss-graph.icon'),
  "mail-fill": () => import('./data/mail-fill.icon'),
  "mail-open": () => import('./data/mail-open.icon'),
  "mail-with-arrow-down": () => import('./data/mail-with-arrow-down.icon'),
  "mail-with-point": () => import('./data/mail-with-point.icon'),
  "mail": () => import('./data/mail.icon'),
  "manager": () => import('./data/manager.icon'),
  "map": () => import('./data/map.icon'),
  "media-folder": () => import('./data/media-folder.icon'),
  "meeting-duration": () => import('./data/meeting-duration.icon'),
  "meeting-notes": () => import('./data/meeting-notes.icon'),
  "meeting-sort": () => import('./data/meeting-sort.icon'),
  "meeting-video": () => import('./data/meeting-video.icon'),
  "meeting": () => import('./data/meeting.icon'),
  "meetings-average": () => import('./data/meetings-average.icon'),
  "meetings-open-follow-ups": () => import('./data/meetings-open-follow-ups.icon'),
  "meetings-transcription": () => import('./data/meetings-transcription.icon'),
  "merge": () => import('./data/merge.icon'),
  "message-with-dot": () => import('./data/message-with-dot.icon'),
  "message": () => import('./data/message.icon'),
  "microsoft-365": () => import('./data/microsoft-365.icon'),
  "migrate": () => import('./data/migrate.icon'),
  "minus": () => import('./data/minus.icon'),
  "model-redeem": () => import('./data/model-redeem.icon'),
  "model-subscribe": () => import('./data/model-subscribe.icon'),
  "money-bag": () => import('./data/money-bag.icon'),
  "money": () => import('./data/money.icon'),
  "move-folder": () => import('./data/move-folder.icon'),
  "ms-office-check": () => import('./data/ms-office-check.icon'),
  "no-chart-data": () => import('./data/no-chart-data.icon'),
  "no-comments": () => import('./data/no-comments.icon'),
  "no-fields": () => import('./data/no-fields.icon'),
  "no-results": () => import('./data/no-results.icon'),
  "not-placement-staged-status": () => import('./data/not-placement-staged-status.icon'),
  "notes-fill": () => import('./data/notes-fill.icon'),
  "notes": () => import('./data/notes.icon'),
  "notification-bell-ring": () => import('./data/notification-bell-ring.icon'),
  "notification-bell": () => import('./data/notification-bell.icon'),
  "number-type-icon": () => import('./data/number-type-icon.icon'),
  "on-off": () => import('./data/on-off.icon'),
  "open-panel": () => import('./data/open-panel.icon'),
  "org-view": () => import('./data/org-view.icon'),
  "organization-details-icon-large": () => import('./data/organization-details-icon-large.icon'),
  "organization-details-icon-medium": () => import('./data/organization-details-icon-medium.icon'),
  "organization-details-icon-small": () => import('./data/organization-details-icon-small.icon'),
  "organization-status-field": () => import('./data/organization-status-field.icon'),
  "organizations-home": () => import('./data/organizations-home.icon'),
  "other-settings": () => import('./data/other-settings.icon'),
  "outlook-calendar": () => import('./data/outlook-calendar.icon'),
  "outlook-email": () => import('./data/outlook-email.icon'),
  "padlock": () => import('./data/padlock.icon'),
  "pdf-file": () => import('./data/pdf-file.icon'),
  "pencil-edit": () => import('./data/pencil-edit.icon'),
  "pending": () => import('./data/pending.icon'),
  "person-in-circle": () => import('./data/person-in-circle.icon'),
  "phone-call": () => import('./data/phone-call.icon'),
  "phone-fill": () => import('./data/phone-fill.icon'),
  "phone-outline": () => import('./data/phone-outline.icon'),
  "phone": () => import('./data/phone.icon'),
  "pin": () => import('./data/pin.icon'),
  "pipeline-grouping-mode": () => import('./data/pipeline-grouping-mode.icon'),
  "planet-globe": () => import('./data/planet-globe.icon'),
  "play": () => import('./data/play.icon'),
  "plus": () => import('./data/plus.icon'),
  "pms-route": () => import('./data/pms-route.icon'),
  "points-star": () => import('./data/points-star.icon'),
  "ppt-file": () => import('./data/ppt-file.icon'),
  "prime-trash": () => import('./data/prime-trash.icon'),
  "probability-adjusted-totals": () => import('./data/probability-adjusted-totals.icon'),
  "profit-circle": () => import('./data/profit-circle.icon'),
  "profit-graph": () => import('./data/profit-graph.icon'),
  "ptc-breach-fail": () => import('./data/ptc-breach-fail.icon'),
  "ptc-breach-warning": () => import('./data/ptc-breach-warning.icon'),
  "rebalance": () => import('./data/rebalance.icon'),
  "rebalancing-list": () => import('./data/rebalancing-list.icon'),
  "recent-meetings-empty": () => import('./data/recent-meetings-empty.icon'),
  "recurring-arrows": () => import('./data/recurring-arrows.icon'),
  "recycle": () => import('./data/recycle.icon'),
  "refresh": () => import('./data/refresh.icon'),
  "reload": () => import('./data/reload.icon'),
  "reorder": () => import('./data/reorder.icon'),
  "repeat": () => import('./data/repeat.icon'),
  "replay": () => import('./data/replay.icon'),
  "report-page": () => import('./data/report-page.icon'),
  "retire-contact": () => import('./data/retire-contact.icon'),
  "retired-contact": () => import('./data/retired-contact.icon'),
  "reverse-clock": () => import('./data/reverse-clock.icon'),
  "revert": () => import('./data/revert.icon'),
  "review-files": () => import('./data/review-files.icon'),
  "rhombus-dot-inside": () => import('./data/rhombus-dot-inside.icon'),
  "row-child-relation": () => import('./data/row-child-relation.icon'),
  "save-to-new-view": () => import('./data/save-to-new-view.icon'),
  "save-to-this-view": () => import('./data/save-to-this-view.icon'),
  "scales": () => import('./data/scales.icon'),
  "scan": () => import('./data/scan.icon'),
  "search-organizations": () => import('./data/search-organizations.icon'),
  "search": () => import('./data/search.icon'),
  "securities-home": () => import('./data/securities-home.icon'),
  "securities-stats-bankdebt": () => import('./data/securities-stats-bankdebt.icon'),
  "securities-stats-bond": () => import('./data/securities-stats-bond.icon'),
  "securities-stats-currency": () => import('./data/securities-stats-currency.icon'),
  "securities-stats-equity": () => import('./data/securities-stats-equity.icon'),
  "securities-stats-fund": () => import('./data/securities-stats-fund.icon'),
  "securities-stats-future": () => import('./data/securities-stats-future.icon'),
  "securities-stats-option": () => import('./data/securities-stats-option.icon'),
  "securities-stats-pfd": () => import('./data/securities-stats-pfd.icon'),
  "security-details-icon": () => import('./data/security-details-icon.icon'),
  "select-files": () => import('./data/select-files.icon'),
  "shapes": () => import('./data/shapes.icon'),
  "share-folder-to-users": () => import('./data/share-folder-to-users.icon'),
  "share": () => import('./data/share.icon'),
  "side-panel": () => import('./data/side-panel.icon'),
  "small-building": () => import('./data/small-building.icon'),
  "sorting": () => import('./data/sorting.icon'),
  "speedometer": () => import('./data/speedometer.icon'),
  "spider-empty": () => import('./data/spider-empty.icon'),
  "square-for-check": () => import('./data/square-for-check.icon'),
  "stage-orders": () => import('./data/stage-orders.icon'),
  "star-empty": () => import('./data/star-empty.icon'),
  "star-filled": () => import('./data/star-filled.icon'),
  "star-medal": () => import('./data/star-medal.icon'),
  "stars-large": () => import('./data/stars-large.icon'),
  "stars": () => import('./data/stars.icon'),
  "starting-cash": () => import('./data/starting-cash.icon'),
  "status": () => import('./data/status.icon'),
  "step-radio-active": () => import('./data/step-radio-active.icon'),
  "step-radio": () => import('./data/step-radio.icon'),
  "subitems": () => import('./data/subitems.icon'),
  "subtasks": () => import('./data/subtasks.icon'),
  "tab-button": () => import('./data/tab-button.icon'),
  "table-view": () => import('./data/table-view.icon'),
  "tag": () => import('./data/tag.icon'),
  "task-suggestion": () => import('./data/task-suggestion.icon'),
  "templates-list-dashed": () => import('./data/templates-list-dashed.icon'),
  "templates-list": () => import('./data/templates-list.icon'),
  "test-campaign": () => import('./data/test-campaign.icon'),
  "test-email-fail": () => import('./data/test-email-fail.icon'),
  "test-email-success": () => import('./data/test-email-success.icon'),
  "test-email": () => import('./data/test-email.icon'),
  "text-type-icon": () => import('./data/text-type-icon.icon'),
  "thin-arrow-right": () => import('./data/thin-arrow-right.icon'),
  "thin-close": () => import('./data/thin-close.icon'),
  "thin-link": () => import('./data/thin-link.icon'),
  "three-hor-lines": () => import('./data/three-hor-lines.icon'),
  "toggle": () => import('./data/toggle.icon'),
  "trades-cash": () => import('./data/trades-cash.icon'),
  "triangle-down-fill": () => import('./data/triangle-down-fill.icon'),
  "trigger": () => import('./data/trigger.icon'),
  "trophy": () => import('./data/trophy.icon'),
  "undelivered": () => import('./data/undelivered.icon'),
  "unlink": () => import('./data/unlink.icon'),
  "unpin": () => import('./data/unpin.icon'),
  "upload-list": () => import('./data/upload-list.icon'),
  "upload-org": () => import('./data/upload-org.icon'),
  "upload": () => import('./data/upload.icon'),
  "user-avatar-placeholder": () => import('./data/user-avatar-placeholder.icon'),
  "user-circle": () => import('./data/user-circle.icon'),
  "user-list": () => import('./data/user-list.icon'),
  "user-management": () => import('./data/user-management.icon'),
  "user-marker": () => import('./data/user-marker.icon'),
  "user": () => import('./data/user.icon'),
  "users-v2": () => import('./data/users-v2.icon'),
  "users": () => import('./data/users.icon'),
  "validate-columns": () => import('./data/validate-columns.icon'),
  "validate-rows": () => import('./data/validate-rows.icon'),
  "vdr-folder": () => import('./data/vdr-folder.icon'),
  "vertical-bottom": () => import('./data/vertical-bottom.icon'),
  "vertical-center": () => import('./data/vertical-center.icon'),
  "vertical-pin-crossed": () => import('./data/vertical-pin-crossed.icon'),
  "vertical-pin": () => import('./data/vertical-pin.icon'),
  "vertical-top": () => import('./data/vertical-top.icon'),
  "widget-panel": () => import('./data/widget-panel.icon'),
  "xls-file-big": () => import('./data/xls-file-big.icon'),
  "xls-file": () => import('./data/xls-file.icon'),
} satisfies Record<IconName, () => Promise<{ readonly icon: IconData }>>;
